
import { Separator } from '@/components/ui/separator';

const PrivacyPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto font-poppins-regular">
      <h1 className="text-3xl font-poppins-bold mb-6">Adatvédelmi Szabályzat</h1>
      <Separator className="mb-8" />
      <section className="mb-6">
        <h2 className="text-xl font-poppins-semibold mb-4">1. Bevezetés</h2>
        <p className="text-gray-700 mb-4">
          Az Ementin Kft. (a továbbiakban: „Szolgáltató") elkötelezett az Ön személyes adatainak védelme iránt. Jelen adatvédelmi szabályzat célja, hogy tájékoztassa Önt arról, hogyan kezeljük az Ön személyes adatait.
        </p>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-poppins-semibold mb-4">2. Adatkezelő Megnevezése</h2>
        <p className="text-gray-700 mb-4">
          Név: Ementin Kft.<br />
          Székhely: 1141 Budapest, Szugló utca 125/G A ép. I. em. 103.<br />
          E-mail: info@medihub.hu<br />
          Telefonszám: +36 1 618 4809<br />
          Adószám: 14806603-2-42<br />
          Cégjegyzékszám: 01-09-920783
        </p>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-poppins-semibold mb-4">3. Kezelt Adatok Köre</h2>
        <p className="text-gray-700 mb-4">
          A Szolgáltató az alábbi személyes adatokat kezeli:
        </p>
        <ul className="list-disc pl-8 text-gray-700 mb-4">
          <li>Név (vezetéknév, keresztnév)</li>
          <li>E-mail cím</li>
          <li>Telefonszám</li>
          <li>Szakmai képesítésre vonatkozó adatok</li>
          <li>Munkahely neve és címe</li>
          <li>Profil- és eseményfotók</li>
          <li>Szolgáltatásaink használatával kapcsolatos adatok (pl. látogatott oldalak, események)</li>
        </ul>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-4">4. Adatkezelés Célja</h2>
        <p className="text-gray-700 mb-4">
          Az Ön személyes adatait az alábbi célokból kezeljük:
        </p>
        <ul className="list-disc pl-8 text-gray-700 mb-4">
          <li>Felhasználói fiók létrehozása és kezelése</li>
          <li>Szolgáltatásaink nyújtása és fejlesztése</li>
          <li>Kapcsolattartás a felhasználókkal</li>
          <li>Személyre szabott tartalmak és ajánlatok megjelenítése</li>
          <li>Statisztikai elemzések készítése</li>
        </ul>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-4">5. Adatkezelés Jogalapja</h2>
        <p className="text-gray-700 mb-4">
          Az adatkezelés jogalapja az alábbiak lehetnek:
        </p>
        <ul className="list-disc pl-8 text-gray-700 mb-4">
          <li>Az Ön hozzájárulása</li>
          <li>Szerződés teljesítése</li>
          <li>Jogi kötelezettség teljesítése</li>
          <li>Jogos érdek</li>
        </ul>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-4">6. Adatok Megőrzése</h2>
        <p className="text-gray-700 mb-4">
          Az Ön személyes adatait addig őrizzük meg, amíg az szükséges a fent említett célok eléréséhez, vagy amíg jogszabályi kötelezettségünk fennáll.
        </p>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-4">7. Adattovábbítás</h2>
        <p className="text-gray-700 mb-4">
          Az Ön személyes adatait harmadik fél részére csak az alábbi esetekben továbbítjuk:
        </p>
        <ul className="list-disc pl-8 text-gray-700 mb-4">
          <li>Az Ön kifejezett hozzájárulásával</li>
          <li>Jogszabályi kötelezettség teljesítése esetén</li>
          <li>Szolgáltatásaink nyújtásához szükséges mértékben, szerződéses partnereink részére</li>
        </ul>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-4">8. Felhasználói Jogok</h2>
        <p className="text-gray-700 mb-4">
          Ön jogosult az alábbi jogok gyakorlására:
        </p>
        <ul className="list-disc pl-8 text-gray-700 mb-4">
          <li>Hozzáférési jog</li>
          <li>Helyesbítéshez való jog</li>
          <li>Törléshez való jog (elfeledtetéshez való jog)</li>
          <li>Adatkezelés korlátozásához való jog</li>
          <li>Adathordozhatósághoz való jog</li>
          <li>Tiltakozáshoz való jog</li>
        </ul>
      </section>
      <div className="mt-8 text-sm text-gray-500">
        <p>Utolsó frissítés: 2024. július 10.</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
